var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      class: _vm.className,
      attrs: { role: "checkbox", "aria-checked": _vm.ariaChecked }
    },
    [
      _vm.formLabel
        ? _c("span", { staticClass: "label" }, [_vm._v(_vm._s(_vm.formLabel))])
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        staticClass: "input",
        attrs: { type: "checkbox" },
        domProps: { checked: _vm.toggled },
        on: {
          change: function($event) {
            $event.stopPropagation()
            return _vm.toggle.apply(null, arguments)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "core", style: _vm.coreStyle },
        [
          _c("div", { staticClass: "button", style: _vm.buttonStyle }),
          _vm._v(" "),
          _vm.labels
            ? [
                _vm.toggled
                  ? _c("span", {
                      staticClass: "label -left",
                      style: _vm.labelStyle,
                      domProps: { innerHTML: _vm._s(_vm.labelChecked) }
                    })
                  : _c("span", {
                      staticClass: "label -right",
                      style: _vm.labelStyle,
                      domProps: { innerHTML: _vm._s(_vm.labelUnchecked) }
                    })
              ]
            : _vm._e()
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d513294", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d513294","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/convenia-components/CToggle.vue
// module id = 7FuJ
// module chunks = 1624